// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"908":"2c1d343a","913":"fbe648d6"}[chunkId] + ".css";
};